'use strict';

/* responsiveFacets */
define(['app', '$window', '$console', 'accordionWidget'], function (app, $window, $console, accordion) {
  return function () {
    var _breakpoint = 900;
    var _noScroll = 'responsiveFacets_noScroll';
    var _containerTransitioned = 'responsiveFacets_container-transitioned';
    var _errorDuration = 3 * 1000;

    var _select = {
      checkbox: '.responsiveFacets_sectionItemCheckbox',
      mobileSectionHead: '.responsiveFacets_sectionHead-mobile',
      sectionContainer: '.responsiveFacets_sectionContainer',
      sectionItem: '.responsiveFacets_sectionItem',
      sectionClear: '.responsiveFacets_sectionClear',
      sectionTitle: '.responsiveFacets_sectionTitle',
      selection: '.responsiveFacets_selection',
      clearAll: '.responsiveFacets_clearAll',
      refine: '.responsiveFacets_refine',
      container: '.responsiveFacets_container',
      saveContainer: '.responsiveFacets_saveContainer',
      save: '.responsiveFacets_save',
      sectionBackArrow: '.responsiveFacets_sectionBackArrow',
      menuClose: '.responsiveFacets_menuClose',
      error: '.responsiveFacets_error'
    };

    var _attr = {
      key: 'data-facet-key',
      value: 'data-facet-value',
      show: 'data-show',
      selected: 'data-selected'
    };

    var _channels = {
      update: 'responsiveProductListPage/update'
    };

    var _accordionConfig = {
      isOpen: true,
      selectors: {
        title: '.responsiveFacets_sectionHead',
        content: '.responsiveFacets_sectionContent'
      },
      offset: 1,
      tracking: {
        enabled: true,
        channel: 'responsiveFacets'
      }
    };

    var _elems = {
      items: [],
      sectionContainers: [],
      container: null,
      refine: null,
      save: null,
      checkboxes: [],
      sectionHeads: [],
      sectionTitles: [],
      selections: [],
      clearAll: null,
      backArrows: [],
      menuCloses: [],
      error: null
    };

    var _mobile = {
      show: false,
      section: -1
    };

    var comp = {
      element: null,
      changes: false,
      facets: [],
      // testing
      _elems: _elems,
      _mobile: _mobile,
      _attr: _attr,
      _channels: _channels,
      _noScroll: _noScroll,
      _breakpoint: _breakpoint
    };

    /**
     * Init
     *
     * @param {HTMLElement} element
     */
    comp.init = function (element) {
      comp.element = element;
      comp.changes = false;

      _elems.items = element.querySelectorAll(_select.sectionItem);
      _elems.container = element.querySelector(_select.container);
      _elems.refine = element.querySelector(_select.refine);
      _elems.saveContainer = element.querySelector(_select.saveContainer);
      _elems.save = element.querySelector(_select.save);
      _elems.sectionContainers = element.querySelectorAll(_select.sectionContainer);
      _elems.checkboxes = element.querySelectorAll(_select.checkbox);
      _elems.sectionHeads = element.querySelectorAll(_select.mobileSectionHead);
      _elems.sectionTitles = element.querySelectorAll(_select.sectionTitle);
      _elems.selections = element.querySelectorAll(_select.selection);
      _elems.clearAll = element.querySelector(_select.clearAll);
      _elems.backArrows = element.querySelectorAll(_select.sectionBackArrow);
      _elems.menuCloses = element.querySelectorAll(_select.menuClose);
      _elems.error = element.querySelector(_select.error);

      if (!_elems.container) {
        return;
      }

      comp.build();
      comp.bind();
      comp.activate();

      // because this component is reinitialised when there's a change to the page,
      // we want to open/close the facets given the state it currently has
      if (_mobile.show) {
        comp.open();
      } else {
        // this removes the left-over noscroll class on body
        comp.close();
      }
    };

    /**
     * Builds facets and accordions.
     */
    comp.build = function () {
      // map each item to its facet value and filter empty values
      comp.facets = Array.from(_elems.items).map(function (item) {
        var checkbox = item.querySelector(_select.checkbox);

        if (!checkbox.checked) {
          return null;
        }

        var key = item.getAttribute(_attr.key);
        var value = item.getAttribute(_attr.value);

        return key + ':' + value;
      }).filter(function (f) {
        return f !== null;
      });

      // initialise accordions for sections without any selections
      _elems.sectionContainers.forEach(function (container, index) {
        if (container.getAttribute(_attr.selected) === 'true') {
          return;
        }

        // make a new object so each accordion has a different config
        var sectionTitle = _elems.sectionTitles[index].innerText;
        var config = Object.assign({}, _accordionConfig);

        config.tracking = Object.assign({}, config.tracking);
        config.tracking.extra = sectionTitle;

        container.componentObject = new accordion().init(container, config);
      });
    };

    /**
     * Binds event listeners to elements.
     */
    comp.bind = function () {
      var _this = this;

      _elems.checkboxes.forEach(function (c, i) {
        return c.addEventListener('change', comp.facetClick.bind(_this, i));
      });
      _elems.sectionHeads.forEach(function (h, i) {
        return h.addEventListener('click', comp.openSection.bind(_this, i));
      });

      _elems.selections.forEach(function (selection) {
        return selection.addEventListener('click', comp.clearSelectionListener);
      });
      _elems.backArrows.forEach(function (arrow) {
        return arrow.addEventListener('click', comp.back);
      });
      _elems.menuCloses.forEach(function (closeArrow) {
        return closeArrow.addEventListener('click', comp.close);
      });

      if (_elems.clearAll) {
        _elems.clearAll.addEventListener('click', comp.clearAll);
      }

      $window.addEventListener('resize', comp.resize);
      _elems.save.addEventListener('click', comp.save);
      _elems.refine.addEventListener('click', comp.open);

      _elems.sectionContainers.forEach(function (container, index) {
        var clearEl = container.querySelector(_select.sectionClear);

        if (clearEl) {
          clearEl._index = index;
          clearEl.addEventListener('click', comp.clearSectionListener);
        }
      });
    };

    /**
     * Activate transition on the container.
     */
    comp.activate = function () {
      // has to be deffered so it applies after comp.open is called in comp.init
      $window.setImmediate(function () {
        _elems.container.classList.add(_containerTransitioned);
      });
    };

    /**
     * Opens mobile facets.
     */
    comp.open = function (ev) {
      $window.document.body.classList.add(_noScroll);
      _elems.container.setAttribute(_attr.show, 'true');

      // only track if the action is initiated by user
      // i.e. it has an event parameter
      if (ev) {
        app.publish('tracking/record', 'responsiveFacets', 'open', 'mobile facets');
      }

      _mobile.show = true;
    };

    /**
     * Closes mobile facets.
     */
    comp.close = function () {
      $window.document.body.classList.remove(_noScroll);
      _elems.container.setAttribute(_attr.show, 'false');

      // desktop cannot close the facets
      // but comp.close is still called even if it's desktop
      if ($window.document.documentElement.clientWidth < _breakpoint) {
        app.publish('tracking/record', 'responsiveFacets', 'close', 'mobile facets');
      }

      // want to clear changes
      comp.changes = 0;

      if (_mobile.section !== -1) {
        _elems.sectionContainers[_mobile.section].setAttribute(_attr.show, 'false');
      }

      _mobile.show = false;
    };

    /**
     * Saves changes and exits facets.
     */
    comp.save = function () {
      if (!comp.changes) {
        // exit when there are no changes to be made
        comp.close(true);
      } else {
        _mobile.section = -1;
        _mobile.show = false;

        comp.update(true);
      }
    };

    /**
     * Clears all facets.
     */
    comp.clearAll = function () {
      comp.facets = [];
      comp.changes = true;

      app.publish('tracking/record', 'responsiveFacets', 'remove', 'all facets');

      comp.update(true);
    };

    /**
     * Return to first mobile page.
     */
    comp.back = function () {
      var sectionTitle = _elems.sectionTitles[_mobile.section].innerText;

      app.publish('tracking/record', 'responsiveFacets', 'close', 'mobile facets section', sectionTitle);

      _elems.sectionContainers[_mobile.section].setAttribute(_attr.show, 'false');
      _mobile.section = -1;

      comp.update(true);
    };

    /**
     * Opens a mobile facet section.
     *
     * @param {number} index
     */
    comp.openSection = function (index) {
      var sectionTitle = _elems.sectionTitles[index].innerText;

      app.publish('tracking/record', 'responsiveFacets', 'open', 'mobile facets section', sectionTitle);

      if (_mobile.section !== -1) {
        _elems.sectionContainers[_mobile.section].setAttribute(_attr.show, 'false');
      }

      _elems.sectionContainers[index].setAttribute(_attr.show, 'true');
      _mobile.section = index;
    };

    /**
     * Resize handler
     */
    comp.resize = function () {
      comp.update();
    };

    /**
     * Facet click handler
     *
     * @param {number} index
     */
    comp.facetClick = function (index) {
      var item = _elems.items[index];

      var key = item.getAttribute(_attr.key);
      var value = item.getAttribute(_attr.value);

      var facet = key + ':' + value;

      app.publish('tracking/record', 'responsiveFacets', 'add', facet);

      if (_elems.checkboxes[index].checked) {
        comp.facets.push(facet);
      } else {
        comp.facets = comp.facets.filter(function (f) {
          return f !== facet;
        });
      }

      comp.changes = true;
      comp.update();
    };

    /**
     * Clear section click handler
     *
     * @param {MouseEvent} ev
     */
    comp.clearSectionListener = function (ev) {
      var index = ev.currentTarget._index;

      if (!_elems.sectionContainers[index]) {
        $console.error('Cannot clear non-existing section at index ' + index + '.');
        return;
      }

      var sectionTitle = _elems.sectionTitles[index].innerText;

      app.publish('tracking/record', 'responsiveFacets', 'remove', 'facet group', sectionTitle);

      var section = _elems.sectionContainers[index];
      var facets = section.querySelectorAll(_select.sectionItem);

      var toRemove = Array.from(facets).map(function (facet) {
        var key = facet.getAttribute(_attr.key);
        var value = facet.getAttribute(_attr.value);

        return key + ':' + value;
      });

      comp.facets = comp.facets.filter(function (f) {
        return !toRemove.includes(f);
      });
      comp.changes = true;

      comp.update(true);
    };

    /**
     * Clear selection click handler
     *
     * @param {MouseEvent} ev
     */
    comp.clearSelectionListener = function (ev) {
      var selection = ev.currentTarget;

      var key = selection.getAttribute(_attr.key);
      var value = selection.getAttribute(_attr.value);
      var facet = key + ':' + value;

      app.publish('tracking/record', 'responsiveFacets', 'remove', facet);

      comp.facets = comp.facets.filter(function (f) {
        return f !== facet;
      });
      comp.changes = true;

      comp.update(true);
    };

    /**
     * Sends the facets to the product list page.
     *
     * Mobile updates are only being sent if the 'force' parameter is set to true.
     *
     * @param {boolean} force forces the facets to be update (mobile only)
     */
    comp.update = function (force) {
      // don' update if it's mobile and non-forcing
      if (!force && $window.document.documentElement.clientWidth < _breakpoint) {
        return;
      }

      if (comp.changes) {
        app.publish(_channels.update, { facetFilters: comp.facets.join('|') });
        _elems.error.setAttribute(_attr.show, 'false');
      }
    };

    /**
     * Displays an alert at the bottom of the screen.
     */
    comp.error = function () {
      _elems.error.setAttribute(_attr.show, 'true');
      _elems.error.style.bottom = _elems.saveContainer.offsetHeight + 'px';

      $window.setTimeout(function () {
        _elems.error.setAttribute(_attr.show, 'false');
      }, _errorDuration);

      app.publish('tracking/record', 'responsiveFacets', 'error', 'new page load');
    };

    return comp;
  };
});
//# sourceMappingURL=responsiveFacets.js.map
